import { call, put, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../../services/apis";

export function* handleFetchAddressSummary({ payload }) {
  try {
    const res = yield call(API.fetchAllCompanies, payload);
    const { data } = res;
    yield put(actions.fetchAddressSummarySuccess(data));
  } catch (err) {
    yield put(actions.fetchAddressSummaryFailure(err?.response?.data));
  }
}

export function* handleFetchTotalCompanies({ payload }) {
  try {
    const res = yield call(API.fetchAllCompanies, payload);
    const { data } = res;
    yield put(actions.fetchTotalCompaniesSuccess(data));
  } catch (err) {
    yield put(actions.fetchTotalCompaniesFailure(err?.response?.data));
  }
}
/**
 * Root saga manages watcher lifecycle
 */
export function* userListingSaga() {
  yield takeLatest(actions.fetchAddressSummary.type, handleFetchAddressSummary);
  yield takeLatest(actions.fetchTotalCompanies.type, handleFetchTotalCompanies);
}
